module.exports = __webpack_public_path__ + "img/tunde.9fffcdba.svg";